import { ToggleButtonGroup, ToggleButtonGroupItem } from "@themis/ui";
import React from "react";
import { PiGridFourFill, PiListBulletsBold } from "react-icons/pi";

import { NotificationsButton } from "@/components/home/notifications/NotificationsButton";
import { Header } from "@/components/Layout/Header";
import { PageLayout } from "@/components/Layout/PageLayout";

import ProjectsHeader from "./components/ProjectsHeader";

export default function Projects() {
  return (
    <PageLayout>
      <Header
        title={<>Projects</>}
        HeaderOptions={
          <ToggleButtonGroup size="lg" type="single">
            <NotificationsButton />
            <ToggleButtonGroupItem aria-label="Grid View" value="grid">
              <PiGridFourFill className="tw-h-[18px] tw-w-[18px]" />
            </ToggleButtonGroupItem>
            <ToggleButtonGroupItem aria-label="Table View" value="table">
              <PiListBulletsBold className="tw-h-[18px] tw-w-[18px]" />
            </ToggleButtonGroupItem>
          </ToggleButtonGroup>
        }
      />
      <ProjectsHeader />
    </PageLayout>
  );
}
